import { render } from "./product-categories.vue?vue&type=template&id=3c102fcc&scoped=true"
import script from "./product-categories.vue?vue&type=script&lang=js"
export * from "./product-categories.vue?vue&type=script&lang=js"

import "./product-categories.vue?vue&type=style&index=0&id=3c102fcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c102fcc"]])

export default __exports__